import {
    EligibilityOffer,
    EligibilityOfferPhase,
    OfferPhaseDuration,
    PriceAndTerm,
} from '@sxm-de/dev-kits/web-sdk/types';

export function offerPricing(offer: EligibilityOffer): {
    free: PriceAndTerm | null;
    introductory: PriceAndTerm | null;
    autoRenewing: PriceAndTerm | null;
} {
    let free: PriceAndTerm | null = null;
    const freePhase = offer.phases.find(({ type }) => type === 'Free');
    if (freePhase) {
        free = buildPriceAndTerm(freePhase);
    }

    let introductory: PriceAndTerm | null = null;
    const introductoryPhase = offer.phases.find(
        ({ type }) => type === 'Introductory',
    );
    if (introductoryPhase) {
        introductory = buildPriceAndTerm(introductoryPhase);
    }

    let autoRenewing: PriceAndTerm | null = null;
    const autoRenewingPhase = offer.phases.find(
        ({ type }) => type === 'AutoRenewing',
    );
    if (autoRenewingPhase) {
        autoRenewing = buildPriceAndTerm(autoRenewingPhase);
    }

    return {
        free,
        introductory,
        autoRenewing,
    };
}

function getTermLength(duration: OfferPhaseDuration): number {
    if ('finite' in duration) {
        return duration.finite.length;
    }
    return 1;
}

function buildPriceAndTerm(phase: EligibilityOfferPhase) {
    const { price, duration } = phase;
    const termLength = getTermLength(duration);
    const priceMonthly = price?.total.value || 0;
    return {
        priceMonthly,
        termLength,
        priceTerm: termLength * priceMonthly,
    };
}
